require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-pilgersdorf.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-pilgersdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-pilgersdorf!./.cache/json/betreuungseinrichtungen-oberpullendorf-pilgersdorf.json
// module id = 989
// module chunks = 231608221292675